import { render, staticRenderFns } from "./leichangDetails.vue?vue&type=template&id=46bf0370&scoped=true&"
import script from "./leichangDetails.vue?vue&type=script&lang=js&"
export * from "./leichangDetails.vue?vue&type=script&lang=js&"
import style0 from "./leichangDetails.vue?vue&type=style&index=0&id=46bf0370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf0370",
  null
  
)

export default component.exports